import requestAction from '../../utils/requestAction'

export const fetchInvoice = (invoiceId: string, clientId?: string, params?: string) => {
  if (!params)
    params = '&limit=1000'
  return requestAction('INVOICE_DETAIL', params)(`invoices/detail?invoiceId=${invoiceId}${clientId ? '&clientId='+clientId: ''}`, 'GET')
}
